import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { GuiaProvider } from "@/components/guia/Guia"; // Prompt M
import { useT } from "@/lib/i18n";

import Login from "@/pages/Login";
import CambiarPassword from "@/pages/CambiarPassword";

import ChoferLayout from "@/pages/chofer/ChoferLayout";
import ChoferHome from "@/pages/chofer/ChoferHome";
import ChoferCargaDetalle from "@/pages/chofer/ChoferCargaDetalle";
import ChoferDiesel from "@/pages/chofer/ChoferDiesel";
import ChoferInsumos from "@/pages/chofer/ChoferInsumos";
import ChoferAyuda from "@/pages/chofer/ChoferAyuda";

import PanelLayout from "@/pages/panel/PanelLayout";
import PanelDia from "@/pages/panel/PanelDia";
import CargaForm from "@/pages/panel/CargaForm";
import CargaDetalle from "@/pages/panel/CargaDetalle";
import Clientes from "@/pages/panel/Clientes";
import Ubicaciones from "@/pages/panel/Ubicaciones";
import Usuarios from "@/pages/panel/Usuarios";
import Jornadas from "@/pages/panel/Jornadas";
import Alertas from "@/pages/panel/Alertas";
import Configuracion from "@/pages/panel/Configuracion";
import Diesel from "@/pages/panel/Diesel";
import Insumos from "@/pages/panel/Insumos";
import Agente from "@/pages/panel/Agente";
import Reportes from "@/pages/panel/Reportes";
import Importar from "@/pages/panel/Importar";

function App() {
  useT(); // vuelve a dibujar toda la app al cambiar el idioma, sin remontarla
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <GuiaProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/cambiar-password" element={<ProtectedRoute><CambiarPassword /></ProtectedRoute>} />

          <Route path="/chofer" element={<ProtectedRoute roles={["chofer"]}><ChoferLayout /></ProtectedRoute>}>
            <Route index element={<ChoferHome />} />
            <Route path="cargas/:id" element={<ChoferCargaDetalle />} />
            <Route path="diesel" element={<ChoferDiesel />} />
            <Route path="insumos" element={<ChoferInsumos />} />
            <Route path="ayuda" element={<ChoferAyuda />} />
          </Route>

          <Route path="/panel" element={<ProtectedRoute roles={["admin", "dispatch", "mantenimiento"]}><PanelLayout /></ProtectedRoute>}>
            <Route index element={<ProtectedRoute roles={["admin", "dispatch"]}><PanelDia /></ProtectedRoute>} />
            <Route path="cargas/nueva" element={<ProtectedRoute roles={["admin", "dispatch"]}><CargaForm /></ProtectedRoute>} />
            <Route path="cargas/:id" element={<ProtectedRoute roles={["admin", "dispatch"]}><CargaDetalle /></ProtectedRoute>} />
            <Route path="cargas/:id/editar" element={<ProtectedRoute roles={["admin", "dispatch"]}><CargaForm /></ProtectedRoute>} />
            <Route path="clientes" element={<ProtectedRoute roles={["admin", "dispatch"]}><Clientes /></ProtectedRoute>} />
            <Route path="ubicaciones" element={<ProtectedRoute roles={["admin", "dispatch"]}><Ubicaciones /></ProtectedRoute>} />
            <Route path="jornadas" element={<ProtectedRoute roles={["admin", "dispatch"]}><Jornadas /></ProtectedRoute>} />
            <Route path="alertas" element={<ProtectedRoute roles={["admin", "dispatch"]}><Alertas /></ProtectedRoute>} />
            <Route path="diesel" element={<ProtectedRoute roles={["admin", "dispatch"]}><Diesel /></ProtectedRoute>} />
            <Route path="insumos" element={<Insumos />} />
            <Route path="agente" element={<ProtectedRoute roles={["admin", "dispatch"]}><Agente /></ProtectedRoute>} />
            <Route path="reportes" element={<ProtectedRoute roles={["admin", "dispatch"]}><Reportes /></ProtectedRoute>} />
            <Route path="importar" element={<ProtectedRoute roles={["admin"]}><Importar /></ProtectedRoute>} />
            <Route path="configuracion" element={<ProtectedRoute roles={["admin"]}><Configuracion /></ProtectedRoute>} />
            <Route path="usuarios" element={<ProtectedRoute roles={["admin"]}><Usuarios /></ProtectedRoute>} />
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        </GuiaProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
